function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import { CTAButtons } from '../../ui/CTAButtons.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import { Text } from '../../ui/Text.js';
import AccordionCell from './AccordionCell.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function HighlightAccordion({
  title,
  subtitle,
  ctaLabel,
  ctaUrl,
  cells,
  anchor,
  style = 'default',
  hasSpacingTop
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    foreground = _componentsThemeMap$s.foreground;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HighlightAccordion",
      children: /*#__PURE__*/jsx(SectionComponentLayout, {
        hasSpacingHorizontal: true,
        anchor: anchor,
        hasNonDefaultBackgroundSpacingVertical: true,
        background: background,
        hasSpacingTop: hasSpacingTop,
        children: /*#__PURE__*/jsxs(Div, {
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexDirection: "column",
          alignSelf: "center",
          width: "100%",
          children: [title && /*#__PURE__*/jsx(Text, {
            as: "h3",
            color: foreground,
            spacingEnd: {
              md: 10
            },
            variant: {
              sm: 'title2',
              md: 'display2'
            },
            children: title
          }), /*#__PURE__*/jsxs(Div, {
            alignItems: "center",
            width: "100%",
            children: [/*#__PURE__*/jsx(Div, {
              flexGrow: 1,
              flexShrink: 1,
              flexBasis: "100%",
              children: subtitle && /*#__PURE__*/jsx(Text, {
                as: "p",
                spacingTop: 2,
                color: foreground,
                spacingEnd: {
                  md: 10
                },
                variant: {
                  sm: 'body',
                  md: 'title4'
                },
                children: subtitle
              })
            }), /*#__PURE__*/jsx(Div, {
              spacingStart: 4,
              flexGrow: 1,
              flexShrink: 1,
              display: {
                sm: 'none',
                md: 'flex'
              },
              children: ctaUrl && ctaLabel && /*#__PURE__*/jsx(CTAButtons, {
                ctaButtonUrl: ctaUrl,
                ctaButtonLabel: ctaLabel,
                contentBackground: background
              })
            })]
          }), /*#__PURE__*/jsx(Div, {
            width: "100%",
            spacingTop: title || subtitle ? 8 : 3,
            flexDirection: "column",
            children: cells && cells.map((fields, index) => {
              return /*#__PURE__*/jsx(AccordionCell, _objectSpread(_objectSpread({
                style: style
              }, fields), {}, {
                borderBottom: cells.length > 1 && index === cells.length - 1
              }), index);
            })
          }), ctaUrl && ctaLabel && /*#__PURE__*/jsx(Div, {
            spacingTop: 5,
            width: "100%",
            display: {
              md: 'none'
            },
            children: /*#__PURE__*/jsx(CTAButtons, {
              ctaButtonUrl: ctaUrl,
              ctaButtonLabel: ctaLabel,
              contentBackground: background
            })
          })]
        })
      })
    })
  });
}
export { HighlightAccordion };
//# sourceMappingURL=HighlightAccordion.js.map
